import { CONST } from "../../CONST";
import { IngredientsEnum } from "../../scenes/BurgerScene";
import { BurgerManager } from "./BurgerManager";
import { recipes } from "./Recipes";

const IngredientTextures = {
    1 : {sat: CONST.BURGER.P_S_EGGS},
    2 : {sat: CONST.BURGER.P_S_LETTUCE},
    3 : {sat: CONST.BURGER.P_S_CHEESE},
    4 : {sat: CONST.BURGER.P_S_TOMATO},
    5 : {sat: CONST.BURGER.P_S_PATTY},
    6 : {sat: CONST.BURGER.P_S_BUN_BOTTOM},
    7 : {sat: CONST.BURGER.P_S_BUN_TOP},
}

const config = {
    normalBurgersAfter:5,
    memeBurgersAfter: 10,
}

export interface Recipe {
    //list of ingredients in order
    ingredients : IngredientsEnum[];
}

export class RecipeManager{
    private scene: Phaser.Scene;
    private recipeDisplay : RecipeDisplay;

    private currentRecipe !: Recipe;

    private recipeQueue : Recipe[];

    constructor(scene: Phaser.Scene){
        this.scene = scene;
        this.recipeDisplay = new RecipeDisplay(scene);
        this.recipeQueue = [];
    }

    public nextRecipe(displayDelay: number, burgerCount: number, firstBurger: boolean = false) : Recipe{
        if (this.recipeQueue.length < 1 || burgerCount == config.normalBurgersAfter || burgerCount == config.memeBurgersAfter){
            this.refillQueue(burgerCount);
        }

        this.currentRecipe = this.recipeQueue.pop();

        if (firstBurger && burgerCount == 0){
            //Add predefined first burger
            this.currentRecipe = recipes.first;
        }

        setTimeout(() => {
            this.recipeDisplay.displayRecipe(this.currentRecipe);
        }, displayDelay);
        return this.currentRecipe;
    }

    private refillQueue(burgerCount: number){
        //TODO: empty queue first?
        if (burgerCount < config.normalBurgersAfter){
            this.recipeQueue.push(...recipes.short);
        } else if (burgerCount == config.normalBurgersAfter){
            this.recipeQueue.push(...recipes.normal);
        } else if (burgerCount == config.memeBurgersAfter){
            this.recipeQueue.push(...recipes.meme);
        } else {
            this.recipeQueue.push(...recipes.short, ...recipes.normal, ...recipes.meme);
        }

        this.recipeQueue = Phaser.Utils.Array.Shuffle(this.recipeQueue);
    }

    public isBurgerCompleted(burger: BurgerManager){
        let burgerIngredients = burger.getCurrentIngredientTypes();
        let recipeIngredients = this.currentRecipe.ingredients;

        if (burgerIngredients.length != recipeIngredients.length){
            return false;
        }

        for (let i = 0; i < recipeIngredients.length; i++){
            if (burgerIngredients[i] !== recipeIngredients[i]){
                return false;
            }
        }

        return true;
    }

    public isBurgerCorrect(burger: BurgerManager){
        let burgerIngredients = burger.getCurrentIngredientTypes();
        let recipeIngredients = this.currentRecipe.ingredients;

        for (let i = 0; i < burgerIngredients.length; i++){
            if (burgerIngredients[i] !== recipeIngredients[i]){
                return false;
            }
        }

        return true;
    }

    public getNextIngredient(burger: BurgerManager){
        let burgerIngredients = burger.getCurrentIngredientTypes();
        let recipeIngredients = this.currentRecipe.ingredients;
    
        if (burgerIngredients.length >= recipeIngredients.length){
            return false;
        }

        return recipeIngredients[burgerIngredients.length];
    }


    public getCurrentRecipeName(){
        return this.currentRecipe.ingredients.join("");
    }

    public getCurrentRecipeLength(){
        return this.currentRecipe.ingredients.length;
    }
}


class RecipeDisplay {
    private DisplayConfig = {
        pos: {active: {x: 749, y: 41}, 
            inactive: {x: 940, y: 64}},
        tween: {
            ease: "Quad.easeInOut",
            duration: 500,
        },
        depth: 70,

        display: {
            startPos: {x: -12, y: 90}, //From (-4, 41) to (-19, 156)
            change: {x: 2.14, y: -16.4},
        }
        
    }

    private scene: Phaser.Scene;

    private currentRecipeDisplay !: Phaser.GameObjects.Container;

    constructor(scene: Phaser.Scene){
        this.scene = scene;
    }

    public displayRecipe(recipe: Recipe){
        if (this.currentRecipeDisplay){
            this.slideRecipe(false);
        }

        this.currentRecipeDisplay = this.createRecipeContainer(recipe);

        this.slideRecipe(true);
    }

    private createRecipeContainer(recipe : Recipe) : Phaser.GameObjects.Container {
        var cont = this.scene.add.container(this.DisplayConfig.pos.inactive.x, this.DisplayConfig.pos.inactive.y).setDepth(this.DisplayConfig.depth);  
        var paper = this.scene.add.image(0, 0, CONST.BURGER.PAPER).setOrigin(0.69, 0.19);
        var ingredients = this.spawnIngredients(recipe);
        
        cont.add([paper, ...ingredients]);
        return cont;
    }

    private spawnIngredients(recipe: Recipe){
        let startPoint = {x: this.DisplayConfig.display.startPos.x - this.DisplayConfig.display.change.x * recipe.ingredients.length/2,
            y: this.DisplayConfig.display.startPos.y - this.DisplayConfig.display.change.y * recipe.ingredients.length/2};
        
        let imgs = [];
        for (let i = 0; i < recipe.ingredients.length; i++){
            imgs.push(
                this.scene.add.image(startPoint.x + i*this.DisplayConfig.display.change.x, 
                                    startPoint.y + i*this.DisplayConfig.display.change.y,
                                    IngredientTextures[recipe.ingredients[i]].sat)
                );
        }

        return imgs;            
    }

    private slideRecipe(slideIn: boolean){
        this.scene.tweens.add({
            targets: this.currentRecipeDisplay,
            x: slideIn ? this.DisplayConfig.pos.active.x : this.DisplayConfig.pos.inactive.x,
            y: slideIn ? this.DisplayConfig.pos.active.y : this.DisplayConfig.pos.inactive.y,
            ease: this.DisplayConfig.tween.ease,
            duration: this.DisplayConfig.tween.duration,
            delay: slideIn ? 2*this.DisplayConfig.tween.duration : 0,
        });
    }
}